import { gql } from '@apollo/client';

export const QUERY_GET_ACTUAL_PRODUCT = gql`
    query products($skus: [String!]!, $pageSize: Int = 1) {
        products(filter: { sku: { in: $skus } }, pageSize: $pageSize) {
            items {
                id
                catalogRule {
                    expire_date
                }
                price_range {
                    minimum_price {
                        discount {
                            amount_off
                            percent_off
                        }
                        regular_price {
                            value
                            currency
                        }
                        final_price {
                            value
                            currency
                        }
                    }
                }
            }
        }
    }
`;

export const QUERY_GET_OPTIMISTIC_RECOMMEND_PRODUCT_GQL = gql`
    query Recommend($skus: [String!]!) {
        Recommend(skus: $skus) {
            items {
                name
                sku
                id
                url_key
                small_image {
                    url
                    label
                }
                media_gallery {
                    url
                    label
                }
            }
        }
    }
`;
export const QUERY_OPTIMISTIC_TRENDING_PRODUCT_GQL = gql`
    query trendingProducts($currentPage: Int = 1, $pageSize: Int = 10) {
        trendingProducts(pageSize: $pageSize, currentPage: $currentPage, sort: { name: DESC }) {
            total_count
            page_info {
                page_size
                current_page
                total_pages
            }
            items {
                name
                sku
                id
                url_key
                small_image {
                    url
                    label
                }
            }
        }
    }
`;
export const QUERY_OPTIMISTIC_POPULAR_PRODUCT_GQL = gql`
    query popularProducts($currentPage: Int = 1, $pageSize: Int = 10) {
        popularProducts(pageSize: $pageSize, currentPage: $currentPage, sort: { name: DESC }) {
            total_count
            page_info {
                page_size
                current_page
                total_pages
            }
            items {
                name
                sku
                id
                url_key
                __typename
                small_image {
                    url
                    label
                }
            }
        }
    }
`;
export const QUERY_OPTIMISTIC_BESTSELLERS_PRODUCT_GQL = gql`
    query bestSellerProducts($currentPage: Int = 1, $pageSize: Int = 5) {
        bestSellerProducts(pageSize: $pageSize, currentPage: $currentPage, sort: { name: DESC }) {
            total_count
            page_info {
                page_size
                current_page
                total_pages
            }
            items {
                name
                sku
                id
                url_key
                thumbnail {
                    url
                    label
                }
                media_gallery {
                    url
                    label
                }
            }
        }
    }
`;
export const QUERY_OPTIMISTIC_RECENTLY_PRODUCT_GQL = gql`
    query Products($recentViewSKU: [String]) {
        products(filter: { sku: { in: $recentViewSKU } }, pageSize: 12) {
            total_count
            items {
                name
                sku
                id
                url_key
                small_image {
                    url
                    label
                }
                __typename
            }
        }
    }
`;
export const QUERY_ACTUAL_PRODUCTS_BY_SKU = gql`
    query products($listSku: [String], $pageSize: Int = 12) {
        products(filter: { sku: { in: $listSku } }, pageSize: $pageSize) {
            total_count
            items {
                id
                catalogRule {
                    expire_date
                }
                reviews(pageSize: 1, currentPage: 1) {
                    total_count
                    summary
                    summary_detail
                }
                thumbnail {
                    url
                    label
                }
                url_key
                __typename
                price_range {
                    minimum_price {
                        discount {
                            amount_off
                            percent_off
                        }
                        regular_price {
                            value
                            currency
                        }
                        final_price {
                            value
                            currency
                        }
                    }
                }
            }
        }
    }
`;
export const QUERY_OFFER_FOR_U_PRODUCT_GQL = gql`
    query Recommend($skus: [String!]!) {
        Recommend(skus: $skus) {
            items {
                name
                sku
                id
                catalogRule {
                    expire_date
                }
                small_image {
                    url
                    label
                }
                url_key
                __typename
                ... on ConfigurableProduct {
                    variants {
                        product {
                            name
                            url_key
                            sku
                            thumbnail {
                                url
                                label
                            }
                            price_range {
                                minimum_price {
                                    discount {
                                        amount_off
                                        percent_off
                                    }
                                    regular_price {
                                        value
                                        currency
                                    }
                                    final_price {
                                        value
                                        currency
                                    }
                                }
                            }
                        }
                        attributes {
                            uid
                            label
                            code
                            value_index
                        }
                    }
                }
            }
        }
    }
`;
export const QUERY_PRODUCT_RELATED_BY_SKU_RECENTLY = gql`
    query relatedProduct($sku: String!, $code: String!) {
        relatedProduct(sku: $sku, code: $code) {
            name
            code
            items {
                sku
            }
        }
    }
`;
export const QUERY_GET_PRODUCT_RELATED_BY_SKU_RECENTLY = gql`
    query relatedProduct($sku: String!, $code: String!) {
        relatedProduct(sku: $sku, code: $code) {
            name
            code
            items {
                sku
            }
        }
    }
`;
